import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import RegionCreateViewModel from "viewModels/timeCharges/distributorEnums/regions/regionCreateViewModel";
import CreateView from "views/common/create";
import RegionForm from "./regionForm";

const RegionCreateView: ViewComponent<RegionCreateViewModel> = observer(({ vm }) => (
  <CreateView vm={vm} form={<RegionForm vm={vm} />} />
));

registerView(RegionCreateView, RegionCreateViewModel);
